export default __webpack_public_path__ + "static/media/tic-tac-toe.442722b5.png";